import {IPaletteType} from "../../../art/components/ArtCreateView/Art";
import magnifier from "../../../../shared/assets/icons/magnifier-plus.svg";
import classNames from "classnames";
import './AssemblyPreview.scss';
import { ArtRenderGrid } from '../../../art/components/ArtCreateView/ArtRenderGrid';

interface IProps {
  schema: any[],
  paletteId: IPaletteType,
  activeBase: number,
  activeArea: number,
  onClick?: (e:any) => void,
}
export const AssemblyPreview = ({schema, paletteId, onClick, activeBase, activeArea}: IProps) => {
  return (
    (schema && schema.length ) ?
    <div className='assembly-preview' onClick={onClick}>
      <div className='art-view-preview'>
        <ArtRenderGrid schema={schema} />
      </div>
      <div className="icon"><img src={magnifier} alt="zoom"/></div>
      <div className="indicator">
        <div className={classNames('indicator-base',{l: (activeBase%2), t:(activeBase>1)})}>
          <div className={classNames('indicator-area',{l: (activeArea%2), t:(activeArea>1)})}></div>
        </div>
      </div>
    </div> : null
  )
}
